var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClosingQuote = function SvgClosingQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 .288v7.168c0 2.39-.047 4.608-.142 6.656-.284 7.168-1.564 12.587-3.838 16.256C41.745 34.123 37.48 36 31.226 36l-1.848-6.144c3.506-.17 5.78-1.323 6.823-3.456 1.043-2.133 1.564-5.035 1.564-8.704h-9.382V.288H48Zm-28.289 0v7.168c0 2.39-.047 4.608-.142 6.656-.284 7.168-1.564 12.587-3.838 16.256C13.456 34.123 9.19 36 2.937 36l-1.848-6.144c3.506-.17 5.78-1.323 6.823-3.456 1.043-2.133 1.564-5.035 1.564-8.704H.094V.288H19.71Z",
    fill: "#333"
  })));
};
export default SvgClosingQuote;